<style lang="stylus">
    .rightclickmenu-aiChartcontent
        .ft-menu
            cursor pointer
            .ft-menutext
                font-size 14px
        floatTool_dropbox()
</style>

<template>
    <div class="rightclickmenu-aiChartcontent">
        <AIFloatMenuPictureAnalysis :fromType="'rightClickMenu'" />
        <div class="ft-aigray-text" :class="{ 'ft-h-divided': !internal }">
            <p>{{ expandContextType === "aiTable" ? $t("AITable") : $t("echartAI") }}</p>
        </div>
        <FtMenu
            :imgIcon="'ai-chart-compare'"
            :text="$t('compare')"
            @clickMenu="clickMenu(aiStatusType.graphCompare, $t('compare'))"
            :placement="'right'"
        />
        <FtMenu
            :imgIcon="'ai-chart-error'"
            :text="$t('error')"
            @clickMenu="clickMenu(aiStatusType.graphAbnormal, $t('error'))"
            :placement="'right'"
        />
        <FtMenu
            :imgIcon="'ai-chart-summarize'"
            :text="$t('summarize')"
            @clickMenu="clickMenu(aiStatusType.graphSummary, $t('summarize'))"
            :placement="'right'"
        />
        <FtMenu :imgIcon="'ai-chart-trend'" :text="$t('trend')" @clickMenu="clickMenu(aiStatusType.graphPredict, $t('trend'))" :placement="'right'" />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import FtMenu from "@/app/components/FloatTool/public/FtMenu.vue";
    import { aiStatusType } from "@/app/components/ai3/enum";
    import AIFloatMenuPictureAnalysis from "@/app/components/FloatTool/AIFloatMenuPictureAnalysis.vue";

    @Component({
        components: {
            FtMenu,
            AIFloatMenuPictureAnalysis,
        },
    })
    export default class AiChart extends Vue {
        @Prop() expandContextType;

        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get aiStatusType() {
            return aiStatusType;
        }
        clickMenu(id, label) {
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                this.$bus.$emit("aiAnalyse", id, label);
                this.aiTrackData(id);
            });
            this.$store.commit("closeContext");
        }
        aiTrackData(id) {
            const obj = {
                [aiStatusType.graphCompare]: "Data Comparison",
                [aiStatusType.graphAbnormal]: "Anomaly Identification",
                [aiStatusType.graphSummary]: "Summary",
                [aiStatusType.graphPredict]: "Trends Prediction",
            };
            this.sensors.track("clickChartAI", {
                Catalogues: "echartAI",
                click_type: obj[id],
            });
        }
    }
</script>
<i18n>
{
    "zh": {
        "echartAI": "图表分析",
        "AITable": "表格分析",
        "compare": "数据对比",
        "error": "异常识别",
        "summarize": "概括总结",
        "trend": "趋势预测"
    },
    "en": {
        "echartAI": "Chart Analysis",
        "AITable": "Table Analysis",
        "compare": "Data Comparison",
        "error": "Anomaly Identification",
        "summarize": "Summary",
        "trend": "Trends Prediction"
    },
    "fr": {
        "echartAI": "Analyse de graphique",
        "AITable": "Analisi tabella",
        "compare": "Comparaison des données",
        "error": "Identification des anomalies",
        "summarize": "Résumé",
        "trend": "Prédiction des tendances"
    },
    "de": {
        "echartAI": "Diagrammanalyse",
        "AITable": "Tabellenanalyse",
        "compare": "Datenvergleich",
        "error": "Erkennung von Anomalien",
        "summarize": "Zusammenfassung",
        "trend": "Trendvorhersage"
    },
    "jp": {
        "echartAI": "チャート分析",
        "AITable": "テーブル分析",
        "compare": "データ比較",
        "error": "異常の特定",
        "summarize": "まとめ",
        "trend": "トレンド予測"
    },
    "es": {
        "echartAI": "Análisis de diagrama",
        "AITable": "Análisis de tabla",
        "compare": "Comparación de datos",
        "error": "Identificación de anomalías",
        "summarize": "Resumen",
        "trend": "Predicción de tendencias"
    },
    "pt": {
        "echartAI": "Análise de gráficos",
        "AITable": "Análise de tabela",
        "compare": "Comparação de dados",
        "error": "Identificação de anomalia",
        "summarize": "Resumo",
        "trend": "Previsão de tendências"
    },
    "it": {
        "echartAI": "Analisi grafico",
        "AITable": "Analisis Tabel",
        "compare": "Confronto dei dati",
        "error": "Identificazione delle anomalie",
        "summarize": "Riepilogo",
        "trend": "Previsione tendenze"
    },
    "tw": {
        "echartAI": "圖表分析",
        "AITable": "表格分析",
        "compare": "資料比較",
        "error": "異常識別",
        "summarize": "摘要",
        "trend": "趨勢預測"
    }
}
</i18n>
